import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { connect } from 'react-redux';

import i18n from 'common/locale/i18n';

import getTermsAndCondition from 'modules/general/shared/action/getTermsAndCondition';
import getUserProfile from 'modules/general/my-account/account-info/actions/getUserProfile';
import logout from 'modules/general/shared/action/logout';

import selectGeneralRootReducer from 'modules/general/shared/selectors/selectGeneralRootReducer';

import R from 'common/res/R';

import PopupModal from 'common/components/PopupModal/PopupModal';
import { DRNModal, DRNText } from '@traveloka/district-ui';

import Icon from 'react-native-vector-icons/FontAwesome';
import TOSLogo from 'common/res/svg/TosLogo';

/**
 * @typedef {import('./HeaderMoreMenu').InternalProps} InternalProps
 * @typedef {import('./HeaderMoreMenu').State} State
 */

const style = StyleSheet.create({
  modalContainer: {
    justifyContent: 'flex-start',
    margin: 0,
  },
  modalContentContainer: {
    backgroundColor: R.color.brand,
  },
  modalContentHeaderSection: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: R.spacing.m,
  },
  emptyContentHeaderLeftContainer: {
    minWidth: 50,
    width: 50,
  },
  modalContentHeaderRightContainer: {
    paddingRight: R.spacing.m,
  },
  modalContentFooterSection: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: R.spacing.m,
  },
  modalContentFooterSectionItemContainer: {
    paddingVertical: R.spacing.s,
  },
  whiteFontColor: {
    color: R.color.uiLightPrimary,
  },
});

const TOUCHABLE_ACTIVE_OPACITY = 0.5;

const mapStateToProps = state => ({
  accountInfo: selectGeneralRootReducer(state).accountInfo,
});

const mapDispatchToProps = (dispatch, { navigation }) => ({
  getUserProfile: () => dispatch(getUserProfile()),
  getTermsAndCondition: () => dispatch(getTermsAndCondition()),
  logout: () => {
    dispatch(logout());
    navigation.push('Login');
  },
});

/**
 * @extends {React.PureComponent<InternalProps, State>}
 */
@connect(
  mapStateToProps,
  mapDispatchToProps
)
class HeaderMoreMenu extends React.PureComponent {
  /**
   * @constructor
   * @param {InternalProps} props
   */
  constructor(props) {
    super(props);

    /**
     * @type {State}
     */
    this.state = {
      isLogoutConfirmationModalVisible: false,
      isMenuModalVisible: false,
    };

    this.handleHideLogoutConfirmationModal = this.handleHideLogoutConfirmationModal.bind(
      this
    );
    this.handleHideMoreMenuModal = this.handleHideMoreMenuModal.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.handleNavigateToTermAndCondition = this.handleNavigateToTermAndCondition.bind(
      this
    );
    this.handlePressLogoutConfirmationModalYesButton = this.handlePressLogoutConfirmationModalYesButton.bind(
      this
    );
    this.handleShowLogoutConfirmationModal = this.handleShowLogoutConfirmationModal.bind(
      this
    );
    this.handleShowMoreMenuModal = this.handleShowMoreMenuModal.bind(this);
    this.handleNavigateToHelpCenter = this.handleNavigateToHelpCenter.bind(
      this
    );
  }

  handleToggleMoreMenuModal(isVisible, callback) {
    this.setState({ isMenuModalVisible: isVisible }, callback);
  }

  handleHideLogoutConfirmationModal() {
    this.setState({ isLogoutConfirmationModalVisible: false });
  }

  handleHideMoreMenuModal() {
    this.handleToggleMoreMenuModal(false);
  }

  handleLogout() {
    this.handleToggleMoreMenuModal(false, async () => {
      await this.props.getUserProfile();
      this.handleShowLogoutConfirmationModal();
    });
  }

  handleNavigateToTermAndCondition() {
    const { getTermsAndCondition, navigation } = this.props;

    this.handleToggleMoreMenuModal(false, async () => {
      await getTermsAndCondition();
      navigation.navigate('TermsAndCondition');
    });
  }

  handlePressLogoutConfirmationModalYesButton() {
    this.handleHideLogoutConfirmationModal();
    this.props.logout();
  }

  handleShowLogoutConfirmationModal() {
    this.setState({ isLogoutConfirmationModalVisible: true });
  }

  handleShowMoreMenuModal() {
    this.handleToggleMoreMenuModal(true);
  }

  handleNavigateToHelpCenter() {
    const { navigation } = this.props;
    this.handleToggleMoreMenuModal(false, () => {
      navigation.navigate('HelpCenter');
    });
  }

  render() {
    const { accountInfo } = this.props;
    const { isLogoutConfirmationModalVisible, isMenuModalVisible } = this.state;

    const userName = (accountInfo && accountInfo.userName) || '';

    return (
      <View>
        <TouchableOpacity
          activeOpacity={TOUCHABLE_ACTIVE_OPACITY}
          onPress={this.handleShowMoreMenuModal}
        >
          <Icon name={'ellipsis-v'} color={R.color.uiLightPrimary} size={24} />
        </TouchableOpacity>

        {/* Header Triple-Dots Menu Modal */}
        <DRNModal
          animationIn={'slideInDown'}
          animationOut={'slideOutUp'}
          isVisible={isMenuModalVisible}
          style={style.modalContainer}
          onBackButtonPress={this.handleHideMoreMenuModal}
          onBackdropPress={this.handleHideMoreMenuModal}
        >
          <View style={style.modalContentContainer}>
            {/* Menu Header */}
            <View style={style.modalContentHeaderSection}>
              <View style={style.emptyContentHeaderLeftContainer}>
                <DRNText
                  style={style.whiteFontColor}
                  variant={DRNText.VARIANT.UI_SMALL}
                >
                  {' '}
                </DRNText>
              </View>

              <TOSLogo />

              <TouchableOpacity
                activeOpacity={TOUCHABLE_ACTIVE_OPACITY}
                style={style.modalContentHeaderRightContainer}
                onPress={this.handleHideMoreMenuModal}
              >
                <DRNText
                  style={style.whiteFontColor}
                  variant={DRNText.VARIANT.UI_SMALL}
                >
                  {'TUTUP'}
                </DRNText>
              </TouchableOpacity>
            </View>

            {/* Link Section */}
            <View style={style.modalContentFooterSection}>
              <TouchableOpacity
                activeOpacity={TOUCHABLE_ACTIVE_OPACITY}
                style={style.modalContentFooterSectionItemContainer}
                onPress={this.handleNavigateToHelpCenter}
              >
                <DRNText
                  style={style.whiteFontColor}
                  variant={DRNText.VARIANT.UI_SMALL}
                >
                  {'Pusat Bantuan'}
                </DRNText>
              </TouchableOpacity>
              <TouchableOpacity
                activeOpacity={TOUCHABLE_ACTIVE_OPACITY}
                style={style.modalContentFooterSectionItemContainer}
                onPress={this.handleNavigateToTermAndCondition}
              >
                <DRNText
                  style={style.whiteFontColor}
                  variant={DRNText.VARIANT.UI_SMALL}
                >
                  {'Syarat & Ketentuan'}
                </DRNText>
              </TouchableOpacity>

              <TouchableOpacity
                activeOpacity={TOUCHABLE_ACTIVE_OPACITY}
                style={style.modalContentFooterSectionItemContainer}
                onPress={this.handleLogout}
              >
                <DRNText
                  style={style.whiteFontColor}
                  variant={DRNText.VARIANT.UI_SMALL}
                >
                  {'Keluar'}
                </DRNText>
              </TouchableOpacity>
            </View>
          </View>
        </DRNModal>

        {/* Logout Confirmation Modal */}
        <PopupModal
          isVisible={isLogoutConfirmationModalVisible}
          onBackdropPress={this.handleHideLogoutConfirmationModal}
        >
          <PopupModal.Header>{`Keluar akun ${userName}`}</PopupModal.Header>
          <PopupModal.ButtonContainer>
            <PopupModal.Button
              type={PopupModal.Button.type.NEGATIVE}
              text={i18n.getText('btn_no')}
              onPress={this.handleHideLogoutConfirmationModal}
            />
            <PopupModal.Button
              text={i18n.getText('btn_yes')}
              onPress={this.handlePressLogoutConfirmationModalYesButton}
            />
          </PopupModal.ButtonContainer>
        </PopupModal>
      </View>
    );
  }
}

export default HeaderMoreMenu;
